export class Country {
  _id: string;
  name: string = '';
  code: string = '';
  active: boolean = false;
  created: Date;
  updated: Date;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/countries/shared/country.model.ts